import { render } from "./LanguageInfo.vue?vue&type=template&id=25588190&scoped=true"
import script from "./LanguageInfo.vue?vue&type=script&lang=js"
export * from "./LanguageInfo.vue?vue&type=script&lang=js"

import "./LanguageInfo.vue?vue&type=style&index=0&id=25588190&scoped=true&lang=css"

import exportComponent from "/Users/habeebrahman/Documents/htdocs/cdz_projects/wg-frontend-v1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25588190"]])

export default __exports__